import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Checkout } from 'src/app/state/user/checkouts/models/checkout';

@Component({
  selector: 'app-renew-checkout-button',
  templateUrl: './renew-checkout-button.component.html',
  styleUrls: ['./renew-checkout-button.component.scss', '../base-button.scss'],
})
export class RenewCheckoutButtonComponent extends BaseButtonComponent implements OnInit {
  checkout: Checkout;

  @Output()
  renewed = new EventEmitter<Checkout>();

  ngOnInit() {
    this.checkout = this.checkoutsFacade.getCheckoutByRecordId(this.record.id, this.issueDate, this.rhId);
  }

  doRenew() {
    this.doAction(() => {
      this.checkoutsFacade.postRenewCheckout(this.checkout).subscribe(
        () => {
          this.renewed.emit(this.checkout);
        },
        (_err) => {
          this.waiting = false;
          throw _err;
        }
      );
    });
  }
}
